<template>
  <div>
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import { Bar } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

export default {
  extends: Bar,
  props: {
    chartData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    chartOptions: {
      type: Object,
      default: () => ({
        responsive: true,
        maintainAspectRatio: false,
      }),
    },
  },
  watch: {
    chartData: {
      handler(newData) {
        if (this.chartInstance) {
          this.chartInstance.data = newData;
          this.chartInstance.update();
        }
      },
      deep: true,
    },
    chartOptions: {
      handler(newOptions) {
        if (this.chartInstance) {
          this.chartInstance.options = newOptions;
          this.chartInstance.update();
        }
      },
      deep: true,
    },
  },
  methods: {
    renderChart() {
      this.chartInstance = new ChartJS(this.$refs.canvas, {
        type: "bar",
        data: this.chartData,
        options: this.chartOptions,
      });
    },
  },
  mounted() {
    this.renderChart();
  },
};
</script>

<style scoped>
canvas {
  width: 100%;
  height: 400px;
}
</style>
